import { NgModule } from '@angular/core';
import { SharedModule } from '../share/shared.module';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';


@NgModule({
    imports: [
        SharedModule
    ],
    exports: [
        SharedModule,
        HeaderComponent,
        FooterComponent
    ],
    declarations: [
        HeaderComponent,
        FooterComponent
    ]
})
export class TemplateModule { }